import * as actions from './action';

const init = {
  planDetails: {},
  addOns: [],
};

export default (state = init, action) => {
  let newState = { ...state };

  switch (action.type) {
    case actions.SUBSCRIPTION_PUSH_PLAN_DETAILS:
      newState.planDetails = action.payload;
      break;

    case actions.SUBSCRIPTION_PUSH_ADD_ON_DETAILS:
      newState.addOns = action.payload;
      break;

    case actions.SUBSCRIPTION_RESET:
      newState.planDetails = action.payload;
      break;
  }
  return newState;
};
